export const DefaultTextColor = '#211F20'

export const pxToRem = (pxUnit?: number) => {
    if (typeof pxUnit === 'number') return `${pxUnit / 10}rem`

    return undefined
}
